/**
 * Metadatos de estudio/paciente desde un buffer DICOM (dicom-parser).
 */
import dicomParser from 'dicom-parser'

/**
 * @typedef {{
 *   patientName: string,
 *   patientId: string,
 *   studyDate: string,
 *   modality: string,
 *   description: string,
 *   studyInstanceUID: string,
 * }} DicomStudyMeta
 */

/**
 * @param {ArrayBuffer|Uint8Array} buffer
 * @returns {DicomStudyMeta}
 */
export function parseDicomStudyMeta(buffer) {
  const empty = {
    patientName: '',
    patientId: '',
    studyDate: '',
    modality: '',
    description: '',
    studyInstanceUID: '',
  }
  if (!buffer) return empty

  const read = (ds) => ({
    patientName: ds.string('x00100010') || '',
    patientId: ds.string('x00100020') || '',
    studyDate: ds.string('x00080020') || '',
    modality: ds.string('x00080060') || '',
    description: ds.string('x00081030') || '',
    studyInstanceUID: ds.string('x0020000d') || '',
  })

  try {
    const bytes =
      buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer)
    const ds = dicomParser.parseDicom(bytes, { untilTag: 'x0020000e' })
    return read(ds)
  } catch (e) {
    try {
      const bytes =
        buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer)
      const ds = dicomParser.parseDicom(bytes)
      return read(ds)
    } catch (e2) {
      return empty
    }
  }
}

/**
 * @param {string|null|undefined} name
 * @returns {boolean}
 */
export function isPlaceholderPatientName(name) {
  const n = String(name || '')
    .trim()
    .toLowerCase()
  return (
    !n ||
    n === 'desconocido' ||
    n === 'unknown' ||
    n === 'unknown patient' ||
    n === 'sin nombre' ||
    n === 'n/a'
  )
}
